// @flow
import * as React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Grid, Row, Col, Button } from 'react-bootstrap';
import { Link } from 'react-router';
import { Helmet } from 'react-helmet';
import * as organisationCreators from '../../actions/organisations/organisationCreators';
import * as customerCreators from '../../actions/customers/customerCreators';
import { checkLoggedInUserIsGlobalAdmin } from '../../actions/authentication/authCreators';
import { removeUserFromOrganisation } from '../../actions/users/organisationCreators';
import CustomerSidebar from './CustomerSidebar';
import CustomerTabSidebar from './CustomerTabSidebar';
import { Building } from '../../components/Icons';
import HelpWrapper from '../../components/HelpWrapper';
import { getSetting } from '../../actions/settings/settingsCreators';
import type { Dispatch } from 'redux';
import type { Organisation } from '../../types';

type Props = {
  params: {
    customerId?: string
  },
  routes: any,
  children: any,
  organisations: Array<Organisation>,
  customers: Array<Organisation>,
  settings?: ?Object,
  getCustomerSettings: (i?: ?number) => Promise<void>,
  getSetting: (s: string) => void,
  checkLoggedInUserIsGlobalAdmin: () => void,
  clearCurrentCustomer: () => { +type: string },
  updateCurrentCustomer: (i: number, s?: boolean) => Promise<Organisation>
};

class Customers extends React.Component<Props> {
  componentWillMount() {
    const context = this.getContext(this.props);
    if (context === 'global') {
      this.props.checkLoggedInUserIsGlobalAdmin();
    }
    this.props.getCustomerSettings();
  }

  componentWillReceiveProps(nextProps: Props) {
    const urlIdChanged =
      this.props.params.customerId !== nextProps.params.customerId;

    if (urlIdChanged) {
      this.handleCustomerIdUpdate(nextProps);
    }
  }

  componentDidMount() {
    const { params, getSetting } = this.props;
    // customerId present in URL means user is on the customer details page
    if (params.customerId) {
      getSetting('customerDetailHelpPdf');
      getSetting('customerDetailHelpVideo');
    } else {
      // No customerId means user is on the global customers page
      getSetting('customerHelpPdf');
      getSetting('customerHelpVideo');
    }
  }

  getContext = (props: Props) => props.routes[props.routes.length - 1].context;

  handleCustomerIdUpdate = (props: Props) => {
    const customerId = props.params.customerId;
    // url: /customers
    if (!customerId) {
      props.clearCurrentCustomer();
      return;
    }

    // url: /customers/new
    if (customerId === 'new') {
      props.clearCurrentCustomer();
      props.getCustomerSettings();
      return;
    }

    // url: /customers/10
    props.updateCurrentCustomer(parseInt(customerId, 10));
  };

  render() {
    const { settings, params } = this.props;
    const currentComponent = this.props.children
      ? this.props.children.type.displayName
      : '';
    const context = this.getContext(this.props);
    const isGlobalContext = context === 'global';
    const mainContentWidth = isGlobalContext ? 9 : 12;
    return (
      <Grid fluid className="customer-details">
        <Helmet>
          <title>Manage Customers | Campaign Targeter</title>
        </Helmet>
        <Row>
          {isGlobalContext && (
            <Col sm={3} className="sidebar-wrapper">
              <CustomerSidebar
                {...this.props}
                items={this.props.organisations}
              />
            </Col>
          )}

          <Col sm={mainContentWidth}>
            <div>
              <Row>
                {params.customerId ? (
                  <HelpWrapper
                    pdfUrl={
                      settings && settings.customerDetailHelpPdf
                        ? settings.customerDetailHelpPdf.value
                        : undefined
                    }
                    videoUrl={
                      settings && settings.customerDetailHelpVideo
                        ? settings.customerDetailHelpVideo.value
                        : undefined
                    }
                    extraClass={this.props.children ? 'child-page-present' : ''}
                  />
                ) : (
                  <HelpWrapper
                    pdfUrl={
                      settings && settings.customerHelpPdf
                        ? settings.customerHelpPdf.value
                        : undefined
                    }
                    videoUrl={
                      settings && settings.customerHelpVideo
                        ? settings.customerHelpVideo.value
                        : undefined
                    }
                    extraClass={this.props.children ? 'child-page-present' : ''}
                  />
                )}
              </Row>
              {!this.props.children && (
                <div>
                  <Link to={`/customers/new`} className="well-300">
                    <div className="svg-center">
                      <Building height="200px" width="200px" />
                    </div>
                    <Button bsStyle="primary">Create new Customer</Button>
                  </Link>
                </div>
              )}
            </div>
            {this.props.children && (
              <Row className="generic-page">
                <Col sm={4} lg={3} className="customer-sidebar">
                  <CustomerTabSidebar
                    activeTab={currentComponent}
                    id={this.props.params.customerId}
                    context={context}
                  />
                </Col>
                <Col sm={8} lg={9} className="customer-maincontent">
                  {React.cloneElement(this.props.children, { ...this.props })}
                </Col>
              </Row>
            )}
          </Col>
        </Row>
      </Grid>
    );
  }
}

function mapStateToProps(state) {
  return {
    authentication: state.authentication,
    organisations: state.organisations,
    locations: state.locations,
    customers: state.customers,
    currentLocation: state.currentLocation,
    currentCustomer: state.currentCustomer,
    currentOrganisation: state.currentOrganisation,
    settings: state.settings
  };
}

function mapDispatchToProps(dispatch: Dispatch<*>) {
  return bindActionCreators(
    {
      ...organisationCreators,
      ...customerCreators,
      removeUserFromOrganisation,
      checkLoggedInUserIsGlobalAdmin,
      getSetting
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(Customers);



// WEBPACK FOOTER //
// ./src/containers/customer/Customers.js